import React, { useState } from 'react'
import { Box, TextField, IconButton, InputAdornment } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import dataGridStyle from '../../styles/dataGridStyle';
import TableRowActions from '../TableRowActions';
import borderStyle from '../../styles/borderStyle'
import SearchIcon from '@mui/icons-material/Search';

const firstRow = {
    code: "",
    cost_rate: "",
    description: "",
    discType: "Amt",
    id: 1,
    markup: "",
    net_tax: "",
    qty: "",
    tax_amt: "",
    tax_perc: "",
    taxable_amt: "",
    tot_amt: "",
    trade_disc: "",
    trade_rate: ""
}

function ServiceOrder() {
    const [rows, setRows] = useState([firstRow])
    
    const columns = [
        { field: 'id', headerName: 'No', flex: 0.1, minWidth: 40 },
        { field: 'Add Approved Estimate', headerName: 'Add Approved Estimate', flex: 1, minWidth: 250,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root,
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    value={params.row.code}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'code')}
                    onKeyDown={(e) => handleTextFieldKeyDown(e, params.row.id, 'code')}
                />
            ),
        },
        { field: 'Estimate Date', headerName: 'Estimate Date', flex: 1, minWidth: 200,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.description}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'description')}
                />
            ),
        },
        { field: 'Total Parts', headerName: 'Total Parts', flex: 1, minWidth: 200,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.qty}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'qty')}
                />
            ),
        },
        { field: 'Total Labour', headerName: 'Total Labour', flex: 1, minWidth: 200,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.cost_rate}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'cost_rate')}
                />
            ),
        },
        { field: 'Net Total Amount', headerName: 'Net Total Amount', flex: 1, minWidth: 200,
            renderCell: (params) => (
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{
                        style: borderStyle.root
                    }}
                    value={params.row.markup}
                    onChange={(e) => handleFieldChange(e, params.row.id, 'markup')}
                />
            ),
        },
        {
            field: 'delete',
            headerName: '',
            flex:0.8,
            minWidth: 90,
            renderCell: (params) => (
                <TableRowActions rows={rows} params={params} setRows={setRows} firstRow={firstRow} field='code'/>
            ),
        },
        // Add more columns as needed
    ];

    const handleFieldChange = (e, id, field) => {
        const updatedRows = rows.map((row) => {
            if (row.id === id) {
                return { ...row, [field]: e.target.value };
            }
            return row;
        });
        setRows(updatedRows);
    };
    const handleTextFieldKeyDown = (e, id, field) => {
        // Prevent the default behavior when the spacebar is pressed

      };

    return (

        <Box sx={dataGridStyle.root}>
            <DataGrid
                columnHeaderHeight={30}
                // rowHeight={40}
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
            />
        </Box>

    )
}

export default ServiceOrder